module.exports = __webpack_public_path__ + "static/media/mini-instrumental.12eb29ed.png";